import {ApplicationConfig, importProvidersFrom} from "@angular/core";
import {provideAngularSvgIcon} from "angular-svg-icon";
import {provideToastr} from "ngx-toastr";
import {NgxSmartModalModule} from "ngx-smart-modal";
import {NgCircleProgressModule} from "ng-circle-progress";

export const centruiAppConfig: ApplicationConfig = {
  providers: [
    provideAngularSvgIcon(),
    provideToastr(),
    importProvidersFrom(
      NgxSmartModalModule.forRoot(),
      NgCircleProgressModule.forRoot()
    )
  ]
}
